<template>
  <div
    class="page_container addCommondity"
    v-loading="loading"
    :element-loading-text="loadingtext"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/purchaseIndex/pManageIndex' }"
          >采购管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>设置采购参数</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="form_container">
      <h1>设置采购参数</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>采购数量：</p>
            <div class="input_box">
              <el-input
                v-model="formData.Quantity"
                placeholder="输入采购数量"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>采购价格：</p>
            <div class="input_box">
              <el-input
                v-model="formData.Amount"
                placeholder="输入采购价格"
                maxlength="50"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库商品属性参数记录：</p>
            <div class="select_box">
              <el-select
                v-model="formData.Tags"
                placeholder="请选择属性标签"
                @change="changeLabel"
              >
                <el-option
                  v-for="item in attrLabelList"
                  :key="item.id"
                  :label="item.attrname"
                  :value="item.attrname"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.TagValues"
                placeholder="请选择属性值"
                @focus="focusLableVlue"
              >
                <el-option
                  v-for="item in attrValueList"
                  :key="item.id"
                  :label="item.attrvalue"
                  :value="item.attrvalue"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>采购原因：</p>
            <div class="input_box">
              <el-input
                type="textarea"
                v-model="formData.PurchaseNote"
                placeholder="请输入采购需求说明"
                maxlength="200"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p>付款形式：</p>
            <div class="input_box">
              <el-radio-group v-model="formData.PaymentMethod">
                <el-radio label="1">先款后货</el-radio>
                <el-radio label="2">货到付款</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="pic flex-rowc">
            <el-image :src="detail.logo" fit="contain">
              <div slot="error" class="image-slot flex-rowc">
                <i class="iconfont icon-zanwutupian1"></i>
              </div>
            </el-image>
          </div>
          <p>
            商品ID：<span>{{ detail.id }}</span>
          </p>
          <br />
          <p>商品名称：</p>
          <p>
            <span>{{ detail.commodityname }}</span>
          </p>
          <p>
            <span>{{ detail.commodityname_e }}</span>
          </p>
          <p>
            <span>{{ detail.commodityname_m }}</span>
          </p>
          <p>
            <span>{{ detail.commodityname_t }}</span>
          </p>
          <p>
            <span>{{ detail.commodityname_y }}</span>
          </p>
          <br />
          <p>
            SKU采购编码：<span>{{ detail.sku }}</span>
          </p>
          <p>
            ISBN编码：<span>{{ detail.ISBN }}</span>
          </p>
        </div>
      </div>
     
    </div>
     <div class="form_footer flex-rowl">
        <div class="btn" @click="submit">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    <!-- 主要内容 end -->
  </div>
</template>

<script>
import { queryShop, getAttrLabelList, getAttrLabelValue, addPurchase } from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "addCommondity",
  data() {
    return {
      loading: false,
      loadingtext: "加载中",
      qyid: 0,
      nowDate: "",
      bannerList: "",

      detail: "", // 商品详情

      // 记录类型
      actname: "",
      actnameList: [
        {
          text: "增加",
          value: "add",
        },
        {
          text: "减少",
          value: "reduce",
        },
      ],

      // 属性标签
      attrLabelList: [],
      attrLabel: "",
      // 属性值
      attrValueList: [],
      attrValue: "",

      type: 1, // 1采购入库 2生产入库
      formData: {
        cmid: "",
        SKU: "",
        ISBN: "",
        Brand: "",
        Tags: "",
        TagValues: "",
        Quantity: "",
        Amount: "",
        QuantityReceived: "",
        PaymentMethod: "", // 采购付款方式  =  1 先款后货  2货到付款
        PurchaseNote: "",
        Requester: "",
        OpenType: '', // 申请人的用户类型 = weixin 微信用户，qiye 企业用户 houtai 后台用户 accountid 用户账户id
      },
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    this.handleSearch();
    this.getAttrLabel();
  },
  methods: {
    // 获取商品详情
    handleSearch() {
      let { id } = this.$route.params;
      this.loadingtext = "加载中";
      this.loading = true;
      queryShop({ keyword: id, openid: this.OPENID, qyguid: this.$store.state.USERINFO.qy.qyguid }).then((res) => {
        if (res.id) {
          this.formData.cmid = res.id
          this.formData.SKU = res.sku
          this.formData.ISBN = res.ISBN
          this.formData.Brand = res.brandid
          this.formData.OpenType = this.USERINFO.accountid
          this.formData.Requester = this.OPENID;
          this.detail = res;
        }
        this.loading = false;
      });
    },
    // 获取属性标签
    getAttrLabel() {
      getAttrLabelList().then((res) => {
        let newDate = [];
        res.forEach((v) => {
          if (v.attrstate == "启用") {
            newDate.push(v);
          }
        });
        this.attrLabelList = newDate;
      });
    },
    changeLabel() {
      this.formData.TagValues = "";
    },
    focusLableVlue() {
      let { Tags } = this.formData;
      if (Tags == "") {
        return;
      }
      this.getAttrValue(Tags);
    },
    // 获取属性值
    getAttrValue(attrid) {
      let {cmid} = this.formData
      getAttrLabelValue({cmid, attrid}).then((res) => {
        let newDate = [];
        res.forEach((v) => {
          if (v.isuse) {
            newDate.push(v);
          }
        });
        this.attrValueList = newDate;
      });
    },

    submit() {
      let { formData } = this;
      let params = formData;
      this.loading = true
      let { id } = this.$route.params;
      addPurchase(params).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            this.loading = false
            this.$message.success(data.message);
          }, 500);
          setTimeout(() => {
            // this.$router.back()
            this.$router.push({name: 'pManageIndex', params: {keyword: id}})
          }, 1500);
        } else {
          this.loading = false
          this.$message.fail(data.message);
        }
      });
    },

    handleReturn() {
      let { id } = this.$route.params;
       this.$router.push({name: 'pManageIndex', params: {keyword: id}})
    },
  },
};
</script>
<style lang="less" scoped>
.addCommondity {
  .form_container {
    background: #f6f6f6;
    padding: 39px 70px 90px;
    margin-top: 17px;
    height: 47vh;
    overflow-y: scroll;
    h1 {
      font-size: 20px;
      color: #404d6c;
      margin-bottom: 28px;
    }
    .content_wrap {
      align-items: flex-start;
      .form_wrap {
        flex: 1;
        margin-right: 100px;
        .block {
          margin-bottom: 45px;
          .input_box {
            margin-bottom: 20px;
          }
        }
      }
      .tip_wrap {
        flex: 1;
        .pic {
          width: 100px;
          height: 100px;
          background: #f0eded;
          margin-bottom: 20px;
        }
      }
      p {
        font-size: 18px;
        color: #6e6e6e;
        margin-bottom: 8px;
        &.red {
          font-size: 16px;
          color: #ff0012;
          line-height: 26px;
          // margin-bottom: 0;
        }
        .mark {
          color: #ff0012;
          font-size: 14px;
          margin-right: 4px;
        }
      }
    }
    .form_footer {
      margin-top: 10px;
    }
  }
  .custom_wrap {
    width: 40%;
    height: 49%;
    // padding-right: 30px;
    .diaog_body {
      height: 44vh;
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        color: #ff0012;
        margin: 15px 0 14px;
      }
      .search_box {
        width: 80%;
        height: 40px;
        background: #ffffff;
        border: 1px solid rgba(173, 173, 173, 0.76);
        border-radius: 25px;
        /deep/ .el-input__inner {
          border: none;
          background: none;
        }
        .search_btn {
          width: 60px;
          cursor: pointer;
        }
      }
      .radio_wrap {
        height: 25vh;
        margin-top: 25px;
        overflow-y: scroll;
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
    }
  }
}
</style>